<template>
	<v-list-item link :disabled="!detail.enabled" :to="detail.to">
		<!--<v-list-item-icon />-->
		<v-list-item-content>
			<v-list-item-title class="pl-2">{{ detail.title }}</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
export default {
	props: {
		detail: {
			type: Object,
			default: null
		},
		color: {
			type: String,
			default: "black"
		}
	},
}	
</script>